module.exports = __webpack_public_path__ + "static/media/music.aba2f266.svg";